export enum AdminDashboardRoute {
  ADMINISTRATORS = '/',
  SECTORS_MANAGEMENT = '/sectors-management',
  CODE_INJECTION = '/code-injection',
}
